import React, { useEffect, useState, useRef } from 'react'
import { Button } from '@ow/comps'
import Search from './Search'
import useMap from './use-map'

const Render = function ({ opts = {}, onChange, formControl, value }) {
  const { slug } = opts
  const { setValue } = formControl
  const [isShowMap, setIsShowMap] = useState(false)
  const [locationName, setLocationName] = useState('')
  const [selectLocation, setSelectLocation] = useState(null)

  const isSelected = useRef(false)

  const containerSlug = `${slug}-container`
  const inputId = `${slug}-keyword`

  const {
    init,
    amap,
    AMap,
    icon,
    addPositionEvent,
    regeoCode,
    addMarker,
    setCenter,
  } = useMap(containerSlug)

  // 拖动、编辑操作初始化时的位置（坐标）
  const getLocation = (v, isDragge) => {
    if (isDragge) {
      setSelectLocation(v)
      regeoCode(v.lnglat, '全国', setLocationName)
    } else {
      setSelectLocation({ lnglat: v })
      regeoCode(v, '全国', setLocationName)
    }
  }

  const dealDefaultLocation = () => {
    if (value && value.length && value.length > 1) {
      setCenter(value)
      regeoCode({ lng: value[0], lat: value[1] }, '全国', setLocationName)
      addMarker(value, amap, getLocation)
    }
  }

  useEffect(() => {
    if (amap) {
      // 自动定位
      addPositionEvent(getLocation)
      // 默认值显示
      dealDefaultLocation()
    }
  }, [amap])

  useEffect(() => {
    if (selectLocation) {
      isSelected.current = true
      const { lnglat = {} } = selectLocation
      const { lat, lng } = lnglat
      if (lat && lng) {
        onChange([lng, lat])
      }
      if (locationName) {
        setValue(slug + '_text', locationName)
      }
    }
  }, [selectLocation, locationName])

  return (
    <div className="w-full mt-2">
      {isShowMap ? (
        <div
          className="w-full mt-2 relative"
          style={{ height: '25rem', borderRadius: '0.1rem' }}
          id={containerSlug}
        >
          {amap && (
            <Search
              amap={amap}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              AMap={AMap}
              inputId={inputId}
              selectLocation={selectLocation}
              locationName={locationName}
              updateLocationName={setLocationName}
              getSelectLocation={setSelectLocation}
              icon={icon}
              regeoCode={regeoCode}
              draggeLocation={getLocation}
            />
          )}
        </div>
      ) : (
        <Button
          type="primary"
          onClick={() => {
            setIsShowMap(true)
            init('normal')
          }}
        >
          点击获取地理位置
        </Button>
      )}
    </div>
  )
}
export default Render
